import { TextScreen } from '@strata/react-page-templates';

export const HighmarkWholecarePayerNotes = () => (
    <TextScreen
        pageTitle="Highmark Wholecare Network Essentials"
        content={
            <>
                <p>
                    The following specific requirements are provider obligations related to
                    servicing a Specialty medication for a Highmark Wholecare member. The
                    documentation is not collected in real-time. Failure to submit documentation
                    upon request or meet any of the requirements may result in additional auditing,
                    monetary recoupment of the cost of excess fills, and/or termination from the
                    Highmark Wholecare network by Highmark Wholecare.
                </p>
                <ol>
                    <li>
                        <div className="sds_list--ordered">Care Management Requirements</div>
                        <ul className="sds_list--unordered">
                            <li>
                                Telephonic and/or in-person contact prior to initiation of the
                                medication and throughout total course of treatment.
                            </li>
                            <li>
                                Obtain and retain documented confirmation of Member understanding of
                                medication regimen, purpose of medication, dose, schedule and
                                administration, importance of medication adherence and side effects.
                            </li>
                            <li>
                                Documented telephonic/in person contact on a monthly basis to assess
                                adherence and any adverse reactions or hospitalizations.
                            </li>
                            <li>
                                Place reminder call to Member when refill is within a week of being
                                due.
                            </li>
                            <li>
                                Document verbal confirmation that either the Member or caregiver has
                                been trained on appropriate injection technique and is able to
                                self-administer the correct dose when applicable.
                            </li>
                            <li>
                                Submit documentation of treatment status for all Members. Completion
                                is required in 100% of Members with the exception of:
                                <ul>
                                    <li>Unavoidable hospitalization</li>
                                    <li>Major side effects or intolerance</li>
                                    <li>
                                        Members who change specialty pharmacy providers or leave the
                                        plan during treatment
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <div className="sds_list--ordered">
                            Obtain verbal Member accounting of on-hand inventory prior to shipping
                            additional supplies.
                        </div>
                    </li>
                    <li>
                        <div className="sds_list--ordered">
                            Alert prescriber and/or Highmark Wholecare immediately of any issues
                            related to adjudication at point-of-sale that could result in a lapse of
                            treatment. Further, notify Highmark Wholecare in a timely manner of any
                            evidence of diversion or non-adherence, such as inability to contact the
                            member after multiple attempts, shipment issues, member reporting of
                            excessive on-hand inventories, or Member complaints of side-effects.
                        </div>
                    </li>
                    <li>
                        <div className="sds_list--ordered">
                            For monoclonal antibody Asthma medications, observe the following “No
                            Show” requirements:
                        </div>
                        <ul className="sds_list--ordered">
                            <li>
                                Contact the provider within five business days subsequent to the
                                dispensing and shipment of medication to confirm that the medication
                                was administered to the Member.
                            </li>
                            <li>
                                Document the administration date or “no show status” with reason, if
                                available, for each Member.
                            </li>
                            <li>
                                Reverse any claims for medications dispensed and not administered,
                                and include this administration record with quarterly reporting to
                                Highmark Wholecare.
                            </li>
                        </ul>
                    </li>
                </ol>
            </>
        }
    />
);
